<template>
    <div>
      <div>
        <van-nav-bar title="任务列表" fixed>
        </van-nav-bar>
      </div>

      <div style="margin-bottom: 45px;margin-top: 45px;">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <van-cell-group>
            <div class="van-panel__header van-hairline--bottom" v-for="item in list" :key="item.id" @click="onJump(item.id)">
              <div class="van-panel__title">{{ item.title }}</div>
              <span class="van-panel__desc">
                <van-row>
                  <van-col span="24">内容: {{ item.start_content }}</van-col>
                </van-row>
              </span>
              <span class="van-panel__log">
                <van-tag v-if="item.is_finish" type="success">已完成</van-tag>
                <van-tag v-else type="danger">待完成</van-tag>
                {{ item.start_time }}
              </span>
            </div>
          </van-cell-group>
        </van-list>

      </div>
    </div>
</template>

<script>
  export default {
    components:{
    },
    data() {
      return {
        list: this.$store.state.task.state.list,
        loading: false,
        finished: false,
        page:1,
      };
    },
    beforeRouteLeave(to, from, next) {
      let position = window.scrollY  //记录离开页面的位置
      if (position == null) position = 0
      this.$store.state.task.state.recruitScrollY = position
      next()
    },
    watch: {
      '$route' (to, from) {
        if (to.name === 'task') {//跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
          let recruitScrollY = this.$store.state.task.state.recruitScrollY
          window.scroll(0, recruitScrollY)
        }
      }
    },
    methods: {
      onJump(id) {//跳转到跟进页面
        this.$router.push('task/edit/'+id);
      },
      onClickLeft() {
        this.$router.push('/');
      },
      onLoad() {//上拉加载
        setTimeout(() => {
          this.getList();
        }, 500);
      },
      getList(){//获取列表数据
        this.loading = true;
        this.$api.post('/api/employee/task/list', {
          page:this.page,
        }, data => {
          this.page++;
          for (let i = 0; i < data.data.length; i++) {
            this.$store.state.task.state.list.push(data.data[i]);
          }
          this.list = this.$store.state.task.state.list;
          this.loading = false;
          if (data.data.length < 20) {
            this.finished = true;
          }
        })
      },
    },
    created: function () {
      if(this.page == 1){
        this.list = []
        this.$store.state.task.state.list = [];
      }
    }
  };
</script>

<style scoped>
  .van-panel__log {
    font-size: 14px;
    position: absolute;
    top: 10px;
    right: 15px;
    color: #26a2ff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/task/index.vue